import './StaticPages.css'

export default function PrivacyPage(){
  return (
    <main className="static-page page">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p>This Privacy Policy explains how Healthy Living Blog collects, uses, and protects your information. This is a static site policy for informational purposes only.</p>
        <h2>Information We Collect</h2>
        <p>We do not collect personal information unless you contact us. We may use cookies for analytics and functionality as described in the cookie banner.</p>
        <h2>Third-Party Services</h2>
        <p>We may link to third-party services. Refer to their privacy policies for details.</p>
        <h2>Contact</h2>
        <p>If you have questions, please contact us via our social media channels listed in the site footer.</p>
      </div>
    </main>
  )
}
